import React, { useState, useEffect } from 'react';
import { TextFilter as TelerikTextFilter } from '@progress/kendo-react-data-tools';
import Checkbox from 'shared/inputs/BaseCheckbox';
import FieldsToSelectDropdown from './components/FieldsToSelectDropdown';

const TextFilter = ({
  filter, fieldsNameForSearch = [], onFilterChange, collection, fieldInfo,
}) => {
  const { value } = filter;
  const [compareWithOtherFieldDisplayValue, setCompareWithOtherFieldDisplayValue] = useState(
    filter.compareWithOtherField ? value : null,
  );
  const [compareWithOtherField, setCompareWithOtherField] = useState(filter.compareWithOtherField);

  useEffect(() => {
    setCompareWithOtherField(filter.compareWithOtherField);
  }, [filter.compareWithOtherField]);

  useEffect(() => {
    if (filter.compareWithOtherField) {
      setCompareWithOtherFieldDisplayValue(value);
    }
  }, [value]);

  const handleTextFilterChanged = (event) => {
    const newFilter = {
      ...filter,
      value: event.nextFilter.value,
      fieldMetadata: {
        collection,
      },
      fieldInfo,
    };

    delete newFilter.compareWithOtherField;

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });
  };

  const handleFieldToCompareChanged = (event) => {
    const value = event.target.value.field;

    const newFilter = {
      ...filter,
      value,
      compareWithOtherField: true,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setCompareWithOtherFieldDisplayValue(event.target.value);
  };

  const handleCompareWithOtherFields = ({ value }) => {
    const newFilter = value ? {
      ...filter,
      value: typeof compareWithOtherFieldDisplayValue === 'object'
        ? compareWithOtherFieldDisplayValue?.field : compareWithOtherFieldDisplayValue,
      compareWithOtherField: true,
      fieldMetadata: {
        collection,
      },
      fieldInfo,
    } : {
      field: filter.field,
      operator: filter.operator,
      value,
      fieldMetadata: {
        collection,
      },
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    if (!value) {
      setCompareWithOtherFieldDisplayValue(null);
    }

    setCompareWithOtherField(value);
  };

  return (
    <div className='app-filters-input'>
      {compareWithOtherField && fieldsNameForSearch.length > 0
        ? (
          <FieldsToSelectDropdown
            fields={fieldsNameForSearch}
            onFieldChanged={handleFieldToCompareChanged}
            value={compareWithOtherFieldDisplayValue}
          />
        ) : (
          filter.operator !== 'isempty' && filter.operator !== 'isnotempty'
        ) && <TelerikTextFilter filter={filter} onFilterChange={handleTextFilterChanged} />}
      {fieldsNameForSearch.length > 0 && (
        <div className='filter-cbx-wrapper'>
          <Checkbox
            value={compareWithOtherField}
            label='Compare with other field'
            onChange={handleCompareWithOtherFields}
          />
        </div>
      )}
    </div>
  );
};

export default TextFilter;
